<div class="container-fluid mt-3 ">
    <div class="row justify-content-center">
        <h4 class="col-12 text-center fw-bold">
            Mesure Générique
        </h4>
        <span class="col-12 text-center">
            {{Model.GroupName}}
        </span>
        <span class="col-12 text-center">
            {{Model.Name}}
        </span>
    </div>

    <div class="row rounded-1 background-light mt-3 mb-3 py-3">
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Reference</mat-label>
                <input matInput [(ngModel)]="Model.Reference" placeholder="Reference">
            </mat-form-field>
        </div>
    </div>

    @if (Model.IsPrestationAnnexe) {
        <div class="row rounded-1 background-light mt-3 mb-3 py-3">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Nombre</mat-label>
                    <input matInput [(ngModel)]="Model.Number" placeholder="Nombre">
                </mat-form-field>
            </div>
        </div>
    }

    <div class="row my-3">
        <button appPreventDoubleClick class="col" color="warn" mat-raised-button (throttledClick)="cancelMeasure()">
            Mesure non réalisée
        </button>
    </div>
    <div class="row">
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer
        </button>
    </div>
</div>